/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCalendarContainer_viewer$ref = any;
type AvailabilityCheckerContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type EventCreateContainer_viewer$ref: FragmentReference;
export type EventCreateContainer_viewer = {|
  +id: string,
  +past_referral_sources: ?$ReadOnlyArray<?string>,
  +s_time_zone: ?string,
  +$fragmentRefs: AvailabilityCheckerContainer_viewer$ref & AvailabilityCalendarContainer_viewer$ref,
  +$refType: EventCreateContainer_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "EventCreateContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "past_referral_sources",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_time_zone",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "AvailabilityCheckerContainer_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "AvailabilityCalendarContainer_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '4b073d055d8c57b460d7b37d2dc6f2a0';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Event/Create/__generated__/EventCreateContainer_viewer.graphql.js